/**
 * "Are you still there?" — shown in the last minute before an idle limit.
 * Any key, click or scroll counts as activity, so the button is only the
 * obvious way to say yes.
 */

import { clock } from './WaitingRoom'

export function IdleWarning({ remainingMs, onStillHere }: { remainingMs: number; onStillHere(): void }) {
  return (
    <div className="study-modal" role="alertdialog" aria-labelledby="idle-title">
      <section className="gate">
        <h1 id="idle-title">Are you still there?</h1>
        <p className="hint">The study will end in {clock(remainingMs)} unless you respond.</p>
        <div className="gate-actions">
          <button type="button" className="consent-agree" onClick={onStillHere} data-testid="idle-still-here">
            I'm still here
          </button>
        </div>
      </section>
    </div>
  )
}
